module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    staticClass: "border"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07part01#part1"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("Part One: The Foundation")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07part01#part1"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08part01chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("A Brief History of Yoga")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08part01chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09part01chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The Branches of Yoga")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09part01chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10part01chapter03#ch3"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Yoga Styles")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10part01chapter03#ch3"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11part02#part2"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("Part Two: Yoga Poses")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11part02#part2"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part02chapter01#ch4"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Sun Salutation")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part02chapter01#ch4"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13part02chapter02#ch5"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Standing Poses")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13part02chapter02#ch5"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14part02chapter03#ch6"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Balancing Poses")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14part02chapter03#ch6"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15part02chapter04#ch7"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Seated Poses, Twists, and Abdominal Strengtheners")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15part02chapter04#ch7"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("82")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16part02chapter05#ch8"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Forward Bends and Hip Openers")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16part02chapter05#ch8"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("94")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17part02chapter06#ch9"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Backbends")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17part02chapter06#ch9"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("104")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18part02chapter07#ch10"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Inversions")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/18part02chapter07#ch10"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("118")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19part02chapter08#ch11"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Resting Poses")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/19part02chapter08#ch11"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("124")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/20part03#part3"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("Part Three: Yoga Philosophy")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/20part03#part3"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("133")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21part03chapter01#ch12"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The Eight-Limbed Path")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/21part03chapter01#ch12"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("134")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22part03chapter02#ch13"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The Five Yamas")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/22part03chapter02#ch13"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("146")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/23part03chapter03#ch14"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The Five Niyamas")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/23part03chapter03#ch14"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("152")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part04#part4"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("Part Four: Beyond the Poses")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part04#part4"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("159")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/25part04chapter01#ch15"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Breathing")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/25part04chapter01#ch15"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("162")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26part04chapter02#ch16"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Meditation")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/26part04chapter02#ch16"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("166")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27part04chapter03#ch17"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Mantras")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/27part04chapter03#ch17"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("172")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28part04chapter04#ch18"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Mudras")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/28part04chapter04#ch18"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("174")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29part04chapter05#ch19"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Bandhas")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/29part04chapter05#ch19"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("178")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30part04chapter06#ch20"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chakras")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/30part04chapter06#ch20"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("180")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31part05#part5"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("Part Five: Yoga Off the Mat")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/31part05#part5"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("191")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32part05chapter01#ch21"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Yoga at Work and School")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/32part05chapter01#ch21"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("194")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33part05chapter02#ch22"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Yoga in Transit")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/33part05chapter02#ch22"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("196")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34part05chapter03#ch23"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Yoga in Relationships")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/34part05chapter03#ch23"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("200")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/35part05chapter04#ch24"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Yoga at Rest")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/35part05chapter04#ch24"
    }
  }, [_c('span', {
    staticClass: "color2"
  }, [_c('strong', [_vm._v("202")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36resources#res"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "color2"
  }, [_vm._v("RESOURCES")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36resources#res"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "color2"
  }, [_vm._v("206")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37index#ind"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "color2"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/37index#ind"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "color2"
  }, [_vm._v("208")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2698447a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05-toc.vue
// module id = 69
// module chunks = 0